var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuDotsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 12,
    viewBox: "0 0 3 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 11.9997C0.671573 11.9997 0 11.3798 0 10.6151C0 9.85038 0.671573 9.23047 1.5 9.23047C2.32843 9.23047 3 9.85038 3 10.6151C3 11.3798 2.32843 11.9997 1.5 11.9997Z",
    fill: "#2C2A4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 7.38447C0.671573 7.38447 0 6.76455 0 5.99985C0 5.23515 0.671573 4.61523 1.5 4.61523C2.32843 4.61523 3 5.23515 3 5.99985C3 6.76455 2.32843 7.38447 1.5 7.38447Z",
    fill: "#2C2A4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 2.76923C0.671573 2.76923 0 2.14932 0 1.38462C0 0.619913 0.671573 0 1.5 0C2.32843 0 3 0.619913 3 1.38462C3 2.14932 2.32843 2.76923 1.5 2.76923Z",
    fill: "#2C2A4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDotsIcon);
export default __webpack_public_path__ + "static/media/menu-dots-icon.70aa9d9d6f3251d82b3f57d86b8e6661.svg";
export { ForwardRef as ReactComponent };